export default "__VITE_ASSET__CYla_jmE__"